import React from "react";

function Terms() {
  return (
    <div style={{ padding: "40px", maxWidth: 900, margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms & Conditions</h1>
      <p>Welcome to <strong>ResumeFuel</strong>! These Terms govern your access to and use of our resume and CV-building services. By using our platform, you agree to be legally bound by these terms.</p>

      <h2>1. Use of Services</h2>
      <p>ResumeFuel is intended for personal and professional use to create resumes and CVs. You agree not to use our services for any unlawful or unauthorized purpose.</p>

      <h2>2. User Responsibilities</h2>
      <ul>
        <li>You are responsible for the accuracy and completeness of the information you enter into the platform.</li>
        <li>You agree not to upload any offensive, misleading, or illegal content.</li>
        <li>All information generated via our tools is for personal career development only.</li>
      </ul>

      <h2>3. Intellectual Property</h2>
      <p>The templates, designs, and tools provided by ResumeFuel are owned by us and protected by copyright laws. You may use them for personal use only.</p>

      <h2>4. Payments and Refunds</h2>
      <p>Access to certain premium templates or features may require a one-time payment. All transactions are processed securely via our payment partner. Refunds are issued at our discretion in case of technical issues.</p>

      <h2>5. Account Security</h2>
      <p>If you create an account, you are responsible for maintaining the confidentiality of your login credentials. Notify us immediately if you suspect unauthorized access.</p>

      <h2>6. Termination</h2>
      <p>We may suspend or terminate your access to ResumeFuel without prior notice if you violate these terms.</p>

      <h2>7. Modifications</h2>
      <p>We reserve the right to update these terms at any time. Changes will be posted on this page and effective immediately upon publication.</p>

      <h2>8. Contact</h2>
      <p>If you have any questions about these terms, please contact us.</p>
    </div>
  );
}

export default Terms;
